import {AppStateType} from "./types";
import {createSlice} from "@reduxjs/toolkit";

const initialState: AppStateType = {
  page: 1,
  groupsChapter: 'counter',
  enabledTabIds: [1],
  modalName: null,
  selectedDoorId: null,
  selectedGroupId: null,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    enableTabId: (state, { payload }) => {
      if (!state.enabledTabIds.includes(payload)) {
        state.enabledTabIds.push(payload);
      }
    },
    setModalName: (state, { payload }) => {
      state.modalName = payload;
    },
    setSelectedDoorId: (state, { payload }) => {
      state.selectedDoorId = payload;
    },
    setSelectedGroupId: (state, { payload }) => {
      state.selectedGroupId = payload;
    },
    resetApp: () => {
      return initialState;
    },
  },
});

export const {
  setPage,
  enableTabId,
  setModalName,
  setSelectedDoorId,
  setSelectedGroupId,
  resetApp,
} = appSlice.actions;

export default appSlice.reducer;
